import { connect } from 'react-redux';
import ImageClass from '../../assets';
import { RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import React, { ReactNode } from 'react';


interface ErrorBoundaryProps {
    children: ReactNode;
    token: string | null;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor (props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError (): ErrorBoundaryState {
        return { hasError: true };
    }
    // // eslint-disable-next-line class-methods-use-this
    // componentDidCatch (error: Error, info: any) {
    //     console.error('Caught by error boundary:', error);
    // }

    render () {
        if (this.state.hasError) {
            return (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                    height="100vh"
                    gap={5}
                >
                    <img src={ImageClass.logoLight} alt="LOGO" height={100} width="auto" />
                    <Typography variant="h4" gutterBottom fontWeight={500}>
                        Something went wrong!
                    </Typography>
                    <Button variant="contained" onClick={() => (window.location.href = this.props.token ? '/app/dashboard' : '/login')}>
                        Back To {this.props.token ? 'Dashboard' : 'Login'}
                    </Button>
                </Box>
            );
        }

        return this.props.children;
    }
}

// export default ErrorBoundary;

const mapStateToProps = (state: RootState) => ({
    token: state.app.token
});

export default connect(mapStateToProps)(ErrorBoundary);